import { ORM } from 'redux-orm';
import { Customer, Contract } from './models';

const orm = new ORM({
    stateSelector: (state) => state.orm,
});
orm.register(Customer, Contract);

export default orm;
